import { fetchJson } from './client';

export const floorPlan = {
  convert: (
    sourcePath: string,
    sourceType: 'pdf' | 'dwg' | 'image',
    page?: number,
    dpi?: number,
    makeTransparent?: boolean
  ) =>
    fetchJson('/floorplans/convert', {
      method: 'POST',
      body: JSON.stringify({ sourcePath, sourceType, page, dpi, makeTransparent }),
    }),
  tile: (pngPath: string, rotation?: number) =>
    fetchJson('/floorplans/tile', { method: 'POST', body: JSON.stringify({ pngPath, rotation }) }),
  cancel: (hash: string) =>
    fetchJson('/floorplans/cancel', { method: 'POST', body: JSON.stringify({ hash }) }),
};
